import React from "react";
import { useTranslation } from "react-i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-regular-svg-icons";

import { IMergedReportEntry } from "pages/secure/shared/reports/reportCatalog.types";
import { getReportLockedTooltipId, useReportLockedTooltipControl } from "./ReportLockedTooltipContext";

interface ILockedReportCardProps {
  report: IMergedReportEntry;
  compactModifier: string;
  hasDescription: boolean;
}

export default function LockedReportCard(props: ILockedReportCardProps) {
  const { report, compactModifier, hasDescription } = props;
  const { t } = useTranslation();
  const lockedTooltipMessage = t("You do not have access to view this report.");
  const lockedTooltipId = getReportLockedTooltipId(report.code, "card");
  const { show, lockedTooltipTrigger, onToggle } = useReportLockedTooltipControl(lockedTooltipId);

  return (
    <article className={`reports-list-card reports-list-card--locked${compactModifier}`}>
      <div className={`reports-list-card__body${hasDescription ? "" : " reports-list-card__body--compact"}`}>
        <div className="reports-list-card__text">
          <span className="reports-list-card__title">{t(report.title)}</span>
          {hasDescription ? (
            <span className="reports-list-card__description">{t(report.description)}</span>
          ) : null}
        </div>
        <div className="reports-list-card__actions">
          <OverlayTrigger
            placement="top"
            trigger={lockedTooltipTrigger}
            show={show}
            onToggle={onToggle}
            overlay={<Tooltip id={lockedTooltipId}>{lockedTooltipMessage}</Tooltip>}
          >
            <button type="button" className="reports-list-card__lock-button" aria-label={lockedTooltipMessage}>
              <FontAwesomeIcon className="reports-list-card__lock-icon" icon={faLock} aria-hidden="true" />
            </button>
          </OverlayTrigger>
        </div>
      </div>
    </article>
  );
}
